module.exports = __webpack_public_path__ + "media/images/search-8a286bd2652a5cb2a79f135a79f03aeb.png";